// Entry-point admin SPA.
// Порядок провайдеров: QueryClient → App (внутри которого Tenant + Auth).

import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/App';
import { installNoZoomGuard } from '@/lib/no-zoom';
import { queryClient } from '@/lib/query-client';
import { installStaleChunkReload } from '@/lib/stale-chunk-reload';
import { ensureFreshBuild } from '@/lib/stale-guard';
import { initTelemetry } from '@/lib/track';
import { registerServiceWorker } from '@/sw-register';
import '@/styles/globals.css';

// Телеметрия (docs/service/37): клики, js-ошибки, флаш-таймер. Fire-and-forget.
initTelemetry();

// Страница на телефоне не масштабируется щипком (iOS игнорирует запрет в
// viewport) — иначе она шире экрана и уезжает вбок (владелец 06.10.2026).
installNoZoomGuard();

// Ф2 плана 38: после деплоя старая вкладка ссылается на удалённые чанки —
// ленивый импорт падает. Один reload подтянет свежий index.html (no-store).
installStaleChunkReload();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);

// SW регистрируется только в production-сборке (см. sw-register.ts).
registerServiceWorker();

// Второй рубеж против застрявшей сборки: сверяем загруженный чанк с тем, что
// сервер отдаёт сейчас, и при расхождении сносим SW и перезагружаемся
// (см. lib/stale-guard.ts — жалоба владельца 2026-07-31).
void ensureFreshBuild();
